import React, { Component } from "react";
import { connect } from "react-redux";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { logout } from "../redux/actions";
import httpClient from "../http-client/client";

class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  logout = async () => {
    try {
      let { status } = await httpClient.get("/user/logout");

      if (status === 200) {
        this.props.logout();
        this.props.data.history.push("/");
      }
    } catch (error) {
      // error occur

      console.log("error", error);
    }
  };

  render() {
    return (
      <UncontrolledDropdown inNavbar>
        <DropdownToggle nav caret style={{ color: "white" }}>
          <span>Setting</span>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={this.props.toggleChangePassword}>
            <i className="fas fa-key"></i> Change Password
          </DropdownItem>
          <DropdownItem>
            <i className="fas fa-mobile-alt"></i> Change Number
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={this.logout}>
            <i className="fa fa-sign-out-alt"></i> Logout
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

// const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout())
});

export default connect(null, mapDispatchToProps)(Setting);
